<li class="text-left yyy" href="#">
  <a routerLink="/webshop/basket" [hidden]="NotLogged">
    <i class="icon-sli-basket text-white"></i>
    <span class="hide-s hide-m tooltip"><span class="disflip"> {{translate('Winkelwagen')}}</span> [{{AantalItems}}]<span class="tooltiptext" id="tooltipwinkel">{{translate('Toegevoegd')}}</span></span>
    
  </a>  
    
</li>